import { ErrorApi } from "@/api/cliente"

/**
 * El mensaje que se le enseña a una persona por un error, venga de donde venga.
 *
 * ⚠ **Existe porque el mismo ternario estaba copiado ~140 veces**
 * (`e instanceof ErrorApi ? e.message : "No se pudo…"`). El mensaje del servidor se
 * enseña TAL CUAL —es genérico a propósito cuando debe serlo, como en el acceso—;
 * cualquier otra cosa (un fallo de red, un error de programación) cae al texto de
 * quien llama, que sabe qué se estaba intentando.
 */
export function mensajeDe(error: unknown, porDefecto: string): string {
  return error instanceof ErrorApi ? error.message : porDefecto
}

/** El código del servidor, si lo hay: lo que se dicta al reportar un fallo. */
export function codigoDe(error: unknown): string | undefined {
  return error instanceof ErrorApi ? error.codigo : undefined
}
